import { CustomArray } from "../../../common/CustomArray";
import {DriveRouteItem} from "./DriveRouteItem";
import { GuidUtility } from "../../../common/GuidUtility";

/// <summary>
/// 详细的行驶信息集合 oyyh,20161008添加注释
/// </summary>
export class DriveRouteItems extends CustomArray {

	constructor() {
		super();
		this.count = -1;
		this.time = null;
	}
	
	getRangeItems(startIndex,endIndex)
	{	
		let rangeItems=new Array();
		if(!startIndex || !endIndex)return rangeItems;

		let tempItem=null;
		for(let tempIndex=startIndex;tempIndex<=endIndex ;tempIndex++)
		{	
			tempItem=this.objects[tempIndex];
			rangeItems.push(tempItem);
		}

		return rangeItems;
	}


	static GetDriveRouteItems(objProxy) {
		let routeItems=null;
		if(objProxy==null)return routeItems;

		routeItems=new DriveRouteItems();
		routeItems.count=objProxy.count;
		routeItems.time=objProxy.time;
		let items = objProxy.item;
		let tempRouteItem=null;
		for (let tempIndex in items) 
		{	
			tempRouteItem = DriveRouteItem.GetDriveRouteItem(items[tempIndex]);
			tempRouteItem.id=GuidUtility.getGuid();
			routeItems.push(tempRouteItem);
		}

		return routeItems;
	}

}//end DriveRouteItems

